import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
    mode: 'hash',
    routes: [{
            path: '/',
            redirect: { name: 'Dashboard' }
        },
        {
            path: '/dashboard',
            name: 'Dashboard',
            component: () =>
                import ('@/components/dashboard/Dashboard.vue')
        },
        {
            path: '/input',
            name: 'Input',
            component: () =>
                import ('@/components/input/Input.vue')
        },
        {
            path: '/output',
            name: 'Output',
            component: () =>
                import ('@/components/output/Output.vue')
        },
        {
            path: '/plan',
            name: 'Plan',
            component: () =>
                import ('@/components/plan/plan.vue')
        },
        {
            path: '/channels',
            name: 'Channel',
            component: () =>
                import ('../components/channel/channel.vue')
        },
        {
            path: '/reports',
            name: 'Reports',
            component: () =>
                import ('@/components/reports/Reports.vue')
        },
        {
            path: '/settings',
            name: 'Settings',
            component: () =>
                import ('@/components/settings/Settings.vue')
        },
        {
            path: '*',
            name: 'Pagenotfound',
            component: () =>
                import ('@/components/common/pageNotFound.vue')
        }
    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js